const TOKEN_KEY = "rp_token";
const REFRESH_KEY = "rp_refresh_token";
const USER_KEY = "rp_user";
const EXPIRES_KEY = "rp_token_expires_at";

function resolveBackendUrl() {
  const raw = (process.env.REACT_APP_BACKEND_URL || "").trim();
  if (!raw || raw === "same-origin" || raw === "/") {
    return "";
  }
  return raw.replace(/\/$/, "");
}

const BACKEND_URL = resolveBackendUrl();
const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

let refreshPromise = null;

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY);
}

export function getCachedUser() {
  const token = getToken();
  const cached = localStorage.getItem(USER_KEY);
  if (!token || !cached) return null;
  try {
    return JSON.parse(cached);
  } catch {
    return null;
  }
}

export function getTokenExpiresAt() {
  return localStorage.getItem(EXPIRES_KEY);
}

export function isTokenExpired(bufferMs = 60_000) {
  const raw = getTokenExpiresAt();
  if (!raw) return false;
  const expires = Date.parse(raw);
  if (Number.isNaN(expires)) return false;
  return Date.now() + bufferMs >= expires;
}

export function saveSession({ token, refresh_token, expires_at, user }) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (refresh_token) localStorage.setItem(REFRESH_KEY, refresh_token);
  if (expires_at) localStorage.setItem(EXPIRES_KEY, expires_at);
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  window.dispatchEvent(new CustomEvent("rp:session", { detail: { token, user } }));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(EXPIRES_KEY);
  window.dispatchEvent(new CustomEvent("rp:session", { detail: null }));
}

async function refreshAccessToken() {
  const refreshToken = getRefreshToken();
  if (!refreshToken) throw new Error("no_refresh_token");
  const res = await fetch(`${API_BASE}/auth/refresh`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh_token: refreshToken }),
  });
  if (!res.ok) throw new Error("refresh_failed");
  const data = await res.json();
  saveSession({
    token: data.token,
    expires_at: data.expires_at,
    user: getCachedUser(),
  });
  return data.token;
}

export async function ensureValidToken() {
  const token = getToken();
  if (!token) return null;
  if (!isTokenExpired()) return token;
  if (!refreshPromise) {
    refreshPromise = refreshAccessToken()
      .catch((err) => {
        clearSession();
        throw err;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

export { API_BASE };
